import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { ActionPicker } from "./action-picker";
import { SuggestedActionsList } from "./suggested-actions-list";
/** Step 2 card — shows the actions to execute for the confirmed decision. Inactive until a decision is confirmed or overridden. */
export function Actions(_ref) {
  var isActive = _ref.isActive,
    actions = _ref.actions,
    patientUid = _ref.patientUid,
    reminderId = _ref.reminderId,
    _ref$isOverride = _ref.isOverride,
    isOverride = _ref$isOverride === void 0 ? false : _ref$isOverride,
    _ref$onBack = _ref.onBack,
    onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
    _ref$isBackLoading = _ref.isBackLoading,
    isBackLoading = _ref$isBackLoading === void 0 ? false : _ref$isBackLoading,
    _ref$canGoBack = _ref.canGoBack,
    canGoBack = _ref$canGoBack === void 0 ? true : _ref$canGoBack,
    _ref$stepNumber = _ref.stepNumber,
    stepNumber = _ref$stepNumber === void 0 ? 2 : _ref$stepNumber;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var doneCount = actions.filter(function (a) {
    return a.state === "done";
  }).length;
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-300 border border-sds-base-default bg-sds-base-default p-4 flex flex-col gap-4 transition-opacity ".concat(!isActive ? "opacity-50 pointer-events-none" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 ".concat(isActive ? "bg-sds-brand-default" : "bg-sds-base-secondary")
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-strong ".concat(isActive ? "text-sds-brand-on-brand" : "text-sds-base-tertiary")
  }, stepNumber)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small-strong text-sds-base-default"
  }, t("label.actions", {
    defaultValue: "Actions"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-secondary"
  }, isOverride ? t("label.actions_pick_helper", {
    defaultValue: "Pick the actions you want to perform"
  }) : isActive ? t("label.actions_progress", {
    done: doneCount,
    total: actions.length,
    defaultValue: "{{done}} of {{total}} done — together or one by one"
  }) : t("label.actions_unavailable", {
    defaultValue: "Available once you confirm a decision"
  })))), isActive && isOverride ? /*#__PURE__*/React.createElement(ActionPicker, {
    onBack: onBack,
    isBackLoading: isBackLoading,
    canGoBack: canGoBack
  }) : isActive ? /*#__PURE__*/React.createElement(SuggestedActionsList, {
    actions: actions,
    patientUid: patientUid,
    reminderId: reminderId
  }) : /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-base-secondary"
  }, t("label.actions_inactive_hint", {
    defaultValue: "Confirm a decision above to unlock its actions."
  })));
}